export const BUSINESS_INSURANCE_DATA_REQUEST =
  'BUSINESS_INSURANCE_DATA_REQUEST';
export const BUSINESS_INSURANCE_DATA_SUCCESS =
  'BUSINESS_INSURANCE_DATA_SUCCESS';
export const BUSINESS_INSURANCE_DATA_FAIL = 'BUSINESS_INSURANCE_DATA_FAIL';
